<app-formular-container
  *ngIf="configInitialized"
  [noticeSubType]="noticeSubType"
  [notice]="notice"
  class="formular-container">
</app-formular-container>

<app-unterschwelle-wizard-dialog
  *ngIf="configInitialized">
</app-unterschwelle-wizard-dialog>
